// extracted by mini-css-extract-plugin
module.exports = {"imageFlex":"image-flex-module--image-flex--1t3hY"};